module.exports = __webpack_public_path__ + "static/media/warn.4cd4270e.svg";